import React from "react";
import logoDark from "../assets/logo.png";
import logoLight from "../assets/logo-light.png";

const Logo = ({ variant = "dark", className = "" }) => {
  const src = variant === "light" ? logoLight : logoDark;
  return (
    <a href="#top" className={`flex items-center select-none ${className}`}>
      <img
        src={src}
        alt="Aventa Rekonstrukce"
        className="h-12 md:h-14 w-auto object-contain"
      />
    </a>
  );
};

export default Logo;
